import { useCallback } from 'react';
import Switch, { SwitchProps } from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { useGDirection, useFieldProps, useForm, useFormRefs, useTextFieldError } from '../hooks';
import { Direction } from '../types';

import FormHelperText from './FormHelperText';

interface FormSwitchProps extends SwitchProps {
	id: string;
	description: string;
	dir?: Direction;
}

const FormSwitch: React.FC<FormSwitchProps> = ({ id, dir, description, ...rest }) => {
	const classes = useStyles();

	const form = useForm();
	const innerRef = useFormRefs();
	const fieldProps = useFieldProps(id);
	const fieldError = useTextFieldError(id);
	const direction = useGDirection();

	const handleChange = useCallback((value: number) => {
		form.setFieldValue(id, value, true);
		form.setFieldTouched(id)
	}, [form, id]);

	return (
		<div>
			<div className={classes.container}>
				<Switch
					id={id}
					dir={dir || direction}
					inputRef={(el) => { if (innerRef) innerRef.current[id] = el }}
					{...fieldProps}
					checked={form.values[id]}
					color="primary"
					onChange={(e) => { handleChange(e.target.checked ? 1 : 0) }}
					{...rest}
				/>
				<InputLabel className={classes.InputLabel} htmlFor={id} >{description}</InputLabel>
			</div>
			<FormHelperText text={fieldError} error />
		</div>
	);
}

export default FormSwitch;

const useStyles = makeStyles(({
	inputRoot: {
		width: '100%',
	},
	container: {
		display: 'flex'
	},
	InputLabel: {
		fontFamily: "Assistant-Bold",
		display: 'flex',
		alignItems: 'center',
	}
}));